// extracted by mini-css-extract-plugin
export default {"starIcon":"_9tptui"};